// 对象数组转地址查询参数格式。
export function toQueryString(obj) {
    // 创建一个新的URLSearchParams实例
    const params = new URLSearchParams();

    // 遍历对象，为每个键值对调用append方法
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            params.append(key, obj[key]);
        }
    }

    // 使用toString方法将URLSearchParams对象转换成字符串
    return params.toString();
}

// 示例对象
// const obj = { age: 23, name: 'jack' };

// // 调用函数并打印结果
// console.log(toQueryString(obj));


// 根据当前协议获取当前的http地址
export const getReplacedProtocolHttp = (url: string) => {
    if (window.location.protocol === 'https:') {
        return url.replace('http:', 'https:')
    } 
        return url.replace('https:', 'http:')
    
    return url
}